export default "__VITE_ASSET__B6gIy0FP__"